<template>
  <v-row>
    <v-col cols="12" class="mx-auto">
      <v-switch
        :label="$t('table.visible')"
        :true-value="1"
        :false-value="0"
        v-model="form.visible"
      ></v-switch>
    </v-col>
    <v-col cols="12" md="6">
      <form-group :validator="$v.form.name" name="name" attribute="fields.name">
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            clearable
            type="text"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.name"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>

    <v-col cols="12" md="6">
      <form-group
        :validator="$v.form.min_persons_count"
        name="min_persons_count"
        attribute="fields.min_persons_count"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            clearable
            type="number"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model.number="form.min_persons_count"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>

    <v-col cols="12" md="6">
      <form-group
        :validator="$v.form.max_persons_count"
        name="max_persons_count"
        attribute="fields.max_persons_count"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="number"
            clearable
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model.number="form.max_persons_count"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6">
      <form-group
        :validator="$v.form.priority"
        name="priority"
        attribute="fields.priority"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="number"
            clearable
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model.number="form.priority"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "FirstStep",
  props: {
    form: {
      type: Object,
      default: () => {}
    },

    isEdit: {
      type: Boolean,
      default: false
    }
  },
  inject: ["$v"],
  data() {
    return {
      menu: null
    };
  }
};
</script>
